import { Controller } from '@hotwired/stimulus'
import EasyMDE from 'easymde'

export default class extends Controller {
  connect() {
    new EasyMDE({
      element: this.element,
      toolbar: ['bold', 'italic', '|', 'unordered-list',
                'horizontal-rule', '|', 'clean-block', 'preview'],
      maxHeight: '200px',
      status: false,
      spellChecker: false
    })
  }
}
